export default __webpack_public_path__ + "static/henna3-3e75ce09e3110f1dbe7e8e0fb994015e.png";